import { ElScrollbar, } from "element-plus"
import { computed, } from "vue"
import { useDesign, } from "@/hooks/useDesign"
import { state, } from "@/hooks/usePageLoading.ts"
import { useAppStore, } from "@/store/App"
import AppView from "./AppView.vue"
import Logo from "./Logo.vue"
import Menu from "./Menu.vue"
import TabMenu from "./TabMenu.vue"
import TagView from "./TagView.vue"
import ToolHeader from "./ToolHeader.vue"

const { getPrefixCls, } = useDesign()

const prefixCls = getPrefixCls("layout",)

const pageLoading = computed(() => state.loading,)

export function useRenderLayout() {
  const appStore = useAppStore()

  // 标签页
  const tagsView = computed(() => appStore.getTagsView,)

  // 菜单折叠
  const collapse = computed(() => appStore.getCollapse,)

  // logo
  const logo = computed(() => appStore.logo,)

  // 固定头部
  const fixedHeader = computed(() => appStore.getFixedHeader,)

  // 是否是移动端
  const mobile = computed(() => appStore.getMobile,)

  // 固定菜单
  const fixedMenu = computed(() => appStore.getFixedMenu,)

  const renderClassic = () => {
    return (
      <>
        <div
          class={[
            "absolute top-0 left-0 h-full layout-border__right",
            { "!fixed z-3000": mobile.value, },
          ]}
        >
          {logo.value
            ? (
                <Logo
                  class={[
                    "bg-[var(--left-menu-bg-color)] relative",
                    {
                      "!pl-0": mobile.value && collapse.value,
                      "w-[var(--left-menu-min-width)]": appStore.getCollapse,
                      "w-[var(--left-menu-max-width)]": !appStore.getCollapse,
                    },
                  ]}
                  style="transition: all var(--transition-time-02);"
                >
                </Logo>
              )
            : undefined}
          <Menu class={[{ "!h-[calc(100%-var(--logo-height))]": logo.value, },]}></Menu>
        </div>
        <div
          class={[
            `${prefixCls}-content`,
            "absolute top-0 h-full",
            {
              "w-[calc(100%-var(--left-menu-min-width))] left-[var(--left-menu-min-width)]":
                collapse.value && !mobile.value && !mobile.value,
              "w-[calc(100%-var(--left-menu-max-width))] left-[var(--left-menu-max-width)]":
                !collapse.value && !mobile.value && !mobile.value,
              "fixed !w-full !left-0": mobile.value,
            },
          ]}
          style="transition: all var(--transition-time-02);"
        >
          <ElScrollbar
            v-loading={pageLoading.value}
            class={[
              `${prefixCls}-content-scrollbar`,
              {
                "!h-[calc(100%-var(--top-tool-height)-var(--tags-view-height))] mt-[calc(var(--top-tool-height)+var(--tags-view-height))]":
                fixedHeader.value,
              },
            ]}
          >
            <div
              class={[
                {
                  "fixed top-0 left-0 z-10": fixedHeader.value,
                  "w-[calc(100%-var(--left-menu-min-width))] !left-[var(--left-menu-min-width)]":
                    collapse.value && fixedHeader.value && !mobile.value,
                  "w-[calc(100%-var(--left-menu-max-width))] !left-[var(--left-menu-max-width)]":
                    !collapse.value && fixedHeader.value && !mobile.value,
                  "!w-full !left-0": mobile.value,
                },
              ]}
              style="transition: all var(--transition-time-02);"
            >
              <ToolHeader
                class={[
                  "bg-[var(--top-header-bg-color)]",
                  {
                    "layout-border__bottom": !tagsView.value,
                  },
                ]}
              >
              </ToolHeader>

              {tagsView.value
                ? (
                    <TagView class="layout-border__bottom layout-border__top"></TagView>
                  )
                : undefined}
            </div>

            <AppView></AppView>
          </ElScrollbar>
        </div>
      </>
    )
  }

  const renderTopLeft = () => {
    return (
      <>
        <div class="layout-border__bottom relative flex items-center bg-[var(--top-header-bg-color)] dark:bg-[var(--el-bg-color)]">
          {logo.value ? <Logo class="custom-hover"></Logo> : undefined}

          <ToolHeader class="flex-1"></ToolHeader>
        </div>
        <div class="absolute left-0 top-[var(--logo-height)+1px] h-[calc(100%-1px-var(--logo-height))] w-full flex">
          <Menu class="layout-border__right relative !h-full"></Menu>
          <div
            class={[
              `${prefixCls}-content`,
              "h-full",
              {
                "w-[calc(100%-var(--left-menu-min-width))] left-[var(--left-menu-min-width)]":
                collapse.value,
                "w-[calc(100%-var(--left-menu-max-width))] left-[var(--left-menu-max-width)]":
                  !collapse.value,
              },
            ]}
            style="transition: all var(--transition-time-02);"
          >
            <ElScrollbar
              v-loading={pageLoading.value}
              class={[
                `${prefixCls}-content-scrollbar`,
                {
                  "!h-[calc(100%-var(--tags-view-height))] mt-[calc(var(--tags-view-height))]":
                    fixedHeader.value && tagsView.value,
                },
              ]}
            >
              {tagsView.value
                ? (
                    <TagView
                      class={[
                        "layout-border__bottom absolute",
                        {
                          "!fixed top-0 left-0 z-10": fixedHeader.value,
                          "w-[calc(100%-var(--left-menu-min-width))] !left-[var(--left-menu-min-width)] mt-[calc(var(--logo-height)+1px)]":
                        collapse.value && fixedHeader.value,
                          "w-[calc(100%-var(--left-menu-max-width))] !left-[var(--left-menu-max-width)] mt-[calc(var(--logo-height)+1px)]":
                        !collapse.value && fixedHeader.value,
                        },
                      ]}
                      style="transition: width var(--transition-time-02), left var(--transition-time-02);"
                    >
                    </TagView>
                  )
                : undefined}

              <AppView></AppView>
            </ElScrollbar>
          </div>
        </div>
      </>
    )
  }

  const renderTop = () => {
    return (
      <>
        <div
          class={[
            "flex items-center justify-between bg-[var(--top-header-bg-color)] relative",
            {
              "layout-border__bottom": !tagsView.value,
            },
          ]}
        >
          {logo.value ? <Logo class="custom-hover"></Logo> : undefined}
          <Menu class="h-[var(--top-tool-height)] flex-1 px-2.5"></Menu>
          <ToolHeader></ToolHeader>
        </div>
        <div
          class={[
            `${prefixCls}-content`,
            "w-full",
            {
              "h-[calc(100%-var(--top-tool-height))]": !fixedHeader.value,
              "h-[calc(100%-var(--tags-view-height)-var(--top-tool-height))]": fixedHeader.value,
            },
          ]}
        >
          <ElScrollbar
            v-loading={pageLoading.value}
            class={[
              `${prefixCls}-content-scrollbar`,
              {
                "mt-[var(--tags-view-height)] !pb-[calc(var(--tags-view-height)+var(--app-footer-height))]":
                fixedHeader.value,
                "pb-[var(--app-footer-height)]": !fixedHeader.value,
              },
            ]}
          >
            {tagsView.value
              ? (
                  <TagView
                    class={[
                      "layout-border__bottom layout-border__top relative",
                      {
                        "!fixed w-full top-[calc(var(--top-tool-height)+1px)] left-0": fixedHeader.value,
                      },
                    ]}
                    style="transition: width var(--transition-time-02), left var(--transition-time-02);"
                  >
                  </TagView>
                )
              : undefined}

            <AppView></AppView>
          </ElScrollbar>
        </div>
      </>
    )
  }

  const renderCutMenu = () => {
    return (
      <>
        <div class="layout-border__bottom relative flex items-center bg-[var(--top-header-bg-color)]">
          {logo.value ? <Logo class="custom-hover !pr-3.75"></Logo> : undefined}

          <ToolHeader class="flex-1"></ToolHeader>
        </div>
        <div class="absolute left-0 top-[var(--logo-height)] h-[calc(100%-var(--logo-height))] w-[calc(100%-2px)] flex">
          <TabMenu></TabMenu>
          <div
            class={[
              `${prefixCls}-content`,
              "h-full",
              {
                "w-[calc(100%-var(--tab-menu-min-width))] left-[var(--tab-menu-min-width)]":
                  collapse.value && !fixedMenu.value,
                "w-[calc(100%-var(--tab-menu-max-width))] left-[var(--tab-menu-max-width)]":
                  !collapse.value && !fixedMenu.value,
                "w-[calc(100%-var(--tab-menu-min-width)-var(--left-menu-max-width))] ml-[var(--left-menu-max-width)]":
                  collapse.value && fixedMenu.value,
                "w-[calc(100%-var(--tab-menu-max-width)-var(--left-menu-max-width))] ml-[var(--left-menu-max-width)]":
                  !collapse.value && fixedMenu.value,
              },
            ]}
            style="transition: all var(--transition-time-02);"
          >
            <ElScrollbar
              v-loading={pageLoading.value}
              class={[
                `${prefixCls}-content-scrollbar`,
                {
                  "!h-[calc(100%-var(--tags-view-height))] mt-[calc(var(--tags-view-height))]":
                    fixedHeader.value && tagsView.value,
                },
              ]}
            >
              {tagsView.value
                ? (
                    <TagView
                      class={[
                        "relative layout-border__bottom layout-border__top",
                        {
                          "!fixed top-0 left-0 z-10": fixedHeader.value,
                          "w-[calc(100%-var(--tab-menu-min-width))] !left-[var(--tab-menu-min-width)] mt-[var(--logo-height)]":
                        collapse.value && fixedHeader.value,
                          "w-[calc(100%-var(--tab-menu-max-width))] !left-[var(--tab-menu-max-width)] mt-[var(--logo-height)]":
                        !collapse.value && fixedHeader.value,
                          "!fixed top-0 !left-[var(--tab-menu-min-width)+var(--left-menu-max-width)] z-10":
                        fixedHeader.value && fixedMenu.value,
                          "w-[calc(100%-var(--tab-menu-min-width)-var(--left-menu-max-width))] !left-[var(--tab-menu-min-width)+var(--left-menu-max-width)] mt-[var(--logo-height)]":
                        collapse.value && fixedHeader.value && fixedMenu.value,
                          "w-[calc(100%-var(--tab-menu-max-width)-var(--left-menu-max-width))] !left-[var(--tab-menu-max-width)+var(--left-menu-max-width)] mt-[var(--logo-height)]":
                        !collapse.value && fixedHeader.value && fixedMenu.value,
                        },
                      ]}
                      style="transition: width var(--transition-time-02), left var(--transition-time-02);"
                    >
                    </TagView>
                  )
                : undefined}

              <AppView></AppView>
            </ElScrollbar>
          </div>
        </div>
      </>
    )
  }

  return {
    renderClassic,
    renderTopLeft,
    renderTop,
    renderCutMenu,
  }
}
